export default __webpack_public_path__ + "static/media/appstore.2a8f2a38.png";